export default __webpack_public_path__ + "static/media/01.7f671f80.webp";